/**
 * Color de cada etiqueta del cruce, para pintarla IGUAL en la web y en la
 * generación de imagen/vídeo. Mismos colores que las clases `.ld-pill--*` de
 * `src/styles/global.css` (mantener en sync). El espejo Python está en
 * `functions/podios/render_podio.py` (`_pill_color`).
 *
 * Se decide por el texto de la etiqueta (no por el flag) porque es lo que
 * llega a los renders: 'RC', 'R.Esp', '#N all-time', 'LE', 'Mín.X',
 * 'Mejora Mín.X', 'PB', 'SB'.
 */
export interface PillColor { bg: string; fg: string }

export function pillColor(tag: string): PillColor {
  if (tag.includes('all-time')) return { bg: '#e3b23c', fg: '#4a3202' }; // top-10 histórico: dorado
  if (tag.startsWith('RC')) return { bg: '#d81f2a', fg: '#ffffff' };     // récord del campeonato: rojo (como R.Esp, Riki 2026-07-13)
  if (tag.startsWith('R.Esp')) return { bg: '#d81f2a', fg: '#ffffff' };  // récord de España: rojo
  if (tag.startsWith('LE')) return { bg: '#ff9186', fg: '#52100a' };     // líder español: rojo claro
  if (tag.startsWith('Mín') || tag.startsWith('Mejora Mín')) {
    return /U\d/.test(tag)
      ? { bg: '#cdb6f7', fg: '#321566' }  // mínima de categoría: morado claro
      : { bg: '#6d28d9', fg: '#ffffff' }; // mínima absoluta: morado
  }
  return { bg: '#34a853', fg: '#ffffff' }; // PB / SB: verde
}
